module.exports = __webpack_public_path__ + "static/media/mft.f6a5c66e.svg";